import React from "react";
import CultureFlag from "components/Culture/CultureFlag";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const CultureDropdown = (props: DropdownProps<server.dto.Culture, server.dto.LCID>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={props.options}
    getLabel={culture => culture.text}
    getValue={culture => culture.lcid}
    value={props.value}
    onChange={props.onChange}
    config={{
      placeholder: RESX.Language.SelectLanguage,
      ...props.config
    }}
    renderOption={(culture) => <div className="flex">
      <div>
        <CultureFlag
          lcid={culture.lcid}
          size="large"
          className="margin-right mini"
        />
      </div>
      <div className="grow1">
        {culture.text}
      </div>
    </div>}
  />;
};

export default CultureDropdown;